function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styles from './styles.module.scss';
import icSuccess from 'assets/img/ic_success.png';
import icClose from 'assets/svg/ic_close.svg';
import { formatCurrency } from '@wolffun/system-currency';
import Modal from 'src/Components/Modal';
import { formatRemainTime } from 'src/utils/date';
import Button from '../../Components/Button';
import TradingEventAds from '../../CheckoutProvider/TransactionDetailModal/TradingEventAds';
import { useTestId } from '@wolffun/testable-id';

const TransactionSuccessModal = ({
  hero,
  onClose,
  balance,
  hasSpecialEvent,
  heroEvent
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const {
    hero: {
      tokenId: heroId,
      rentInfo: {
        cost: price,
        rentBattles,
        periodHours
      }
    },
    heroType: {
      name: heroName
    }
  } = hero;
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", _extends({
    className: styles.modal
  }, generateTestIdProps('success-modal')), /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }), /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icSuccess,
    className: styles.icon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Complete!"), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, "You successfully rent #", heroId, " ", heroName, " Hero"), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRow
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Price"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, price ? formatCurrency(price, {
    withCurrency: true
  }) : undefined)), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRow
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Battles for rent"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, rentBattles)), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRow
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Your balance"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, formatCurrency(balance, {
    withCurrency: true
  }))), /*#__PURE__*/React.createElement("span", {
    className: styles.footerContent
  }, "Renter will keep the hero for maximum\xA0", formatRemainTime(periodHours, {
    format: 'DD [days] HH [hours]',
    unit: 'hours'
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    title: "I got it",
    onClick: onClose
  })), hasSpecialEvent && /*#__PURE__*/React.createElement(TradingEventAds, {
    hasEvent: heroEvent
  }))));
};

export default TransactionSuccessModal;